// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d2700605","323":"bee1110c","619":"5e391c55","705":"890eb1b3","717":"6d667ee2","734":"35523b3e","735":"8692bb90","922":"76d64359"}[chunkId] + ".chunk.js";
};